module.exports = __webpack_public_path__ + "static/media/ic_institution.ef886b9a.svg";